import { observer } from 'mobx-react-lite';
import { useState, useEffect, SyntheticEvent } from 'react';
import {
  Button,
  Form,
  Header,
  Input,
  Segment,
  Select,
} from 'semantic-ui-react';
import { Activity } from '../../../../app/models/activity';
import { DeliveryRequest } from '../../../../app/models/deliveryRequest';
import { useStore } from '../../../../app/stores/store';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';
import { User } from '../../../../app/models/user';

function DeliveryAssignPicker() {
  const {
    dashboardStore,
    activityStore,
    userStore,
    DeliveryStore,
    commonStore,
  } = useStore();
  const { userList, loadUsers } = userStore;
  const [deliveryEdit, setDeliveryEdit] = useState<
    DeliveryRequest | undefined
  >();
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [pickerName, setPickerName] = useState('');
  const [pickerEmail, setPickerEmail] = useState<string>('');
  const [ItemLevel, setItemLevel] = useState<Activity | undefined>();
  const [userOptions, setUserOptions] = useState<any>([]);

  useEffect(() => {
    setItemLevel(activityStore.selectedActivity);
    if (activityStore.selectedActivity?.itemDeliveryRequest) {
      setDeliveryEdit(
        activityStore.selectedActivity?.itemDeliveryRequest?.filter(
          (i) => i.isActive === true,
        )?.[0],
      );
    }
    // eslint-disable-next-line
  }, [activityStore.selectedActivity]);

  useEffect(() => {
    if (userList.length === 0) loadUsers();
  }, [userList.length, loadUsers]);

  useEffect(() => {
    setUserOptions(
      userStore.getUsers.map((x) => ({
        key: x.id,
        text: x.displayName,
        value: x.id,
      })),
    );
  }, [userStore.getUsers]);

  const handleChange = (e: SyntheticEvent, data: any) => {
    if (data.value === '') {
      setPhoneNumber('');
      setPickerName('');
    } else {
      const userdata = userList.filter((u: User) => u.id === data.value)?.[0];
      if (userdata?.phoneNumber) {
        setPhoneNumber(
          userdata?.phoneNumber !== undefined ? userdata?.phoneNumber : '',
        );
        setPickerName(userdata?.id !== undefined ? userdata?.id : '');
      } else {
        setPhoneNumber('');
        setPickerName(userdata?.id !== undefined ? userdata?.id : '');
      }
      setPickerEmail(userdata?.email || '');
      // for delivery-Inventory
      if (
        deliveryEdit !== undefined &&
        dashboardStore.dashboard.valueForL3Inventory ===
          'Assign Picker Delivery'
      ) {
        const newArr = {
          ...deliveryEdit,
          pickerName:
            userdata?.displayName !== undefined ? userdata?.displayName : '',
          pickerPhoneNumber:
            userdata?.phoneNumber !== undefined ? userdata?.phoneNumber : '',
          isPickerAssigned: true,
        };
        setDeliveryEdit(newArr);
      }
    }
  };
  // submitting form

  const getInfoById = (id: string, field: string) => {
    const user = userStore.getUsers?.filter((user) => user.id === id);
    switch (field) {
      case 'displayName':
        return user[0]?.displayName;
      default:
        return '';
    }
  };

  const handleSubmit = async () => {
    // for delivery-Inventory
    if (
      dashboardStore.dashboard.valueForL3Inventory ===
        'Assign Picker Delivery' &&
      deliveryEdit !== undefined &&
      ItemLevel !== undefined
    ) {
      const ActArr = {
        ...ItemLevel,
        asset_tracking_status: 'Delivery Asset Picker Assigned',
        movementdate: new Date().toISOString(),
        assignedUsers: [],
        itemDeliveryRequest: [deliveryEdit],
        orders: [],
      };
      const getPickerName = getInfoById(pickerName || '', 'displayName');
      const response = await DeliveryStore.AssignPicker(
        deliveryEdit.id,
        getPickerName,
        phoneNumber,
      );
      sendRespectiveEmail(
        '',
        ActArr.title,
        'Delivery Pickup - Notification',
        '',
        '',
        pickerEmail,
        `Dear ${getPickerName}, <br/>\u00A0  ${ActArr.title} {${ActArr.id}} is assigned to you to pick it up from the vault. <br/> <br/> Regards, <br/> ${userStore.user?.displayName}`,
      );
      DeliveryStore.deleteAssignPicker(deliveryEdit.id);
      setTimeout(() => {
        // DeliveryStore.listAssignPickerDelivery();
        commonStore.updateHistoryAlonePOST(
          response,
          ActArr?.id,
          undefined,
          true,
          true,
        );
        DeliveryStore.listCreateOrder();
      }, 500);
      dashboardStore.dashboard.valueForL3Inventory = 'Create Order';
    } else {
      DeliveryStore.listAssignPickerDelivery();
    }
    dashboardStore.showClickedValueForAssetTable('');
    setItemLevel(undefined);
    setDeliveryEdit(undefined);
  };

  const handleCancel = () => {
    setPhoneNumber('');
    setPickerName('');
    setDeliveryEdit(undefined);
  };

  return (
    <Segment
      style={{
        height: '61.8vh',
        marginTop: '10px',
        marginBottom: '1px',
        overflowY: 'scroll',
        marginRight: '10px',
      }}
    >
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content={
          (
            userLanguage[0].InventoryDeliveryAssignPickerComponent
              ?.IDAPCL01 as any
          )?.[`${commonStore.language.key}`]
        } //Assign Picker
        sub
        color="grey"
      />
      <Header />
      <Header />
      {dashboardStore.dashboard.AssetTableAssignClicked.length !== 0 ? (
        <>
          <Form>
            <Form.Field
              id="picker_name:"
              options={userOptions}
              control={Select}
              label={
                (
                  userLanguage[0].InventoryDeliveryAssignPickerComponent
                    ?.IDAPCL03 as any
                )?.[`${commonStore.language.key}`]
              } //"Picker Name"
              placeholder={
                (
                  userLanguage[0].InventoryDeliveryAssignPickerComponent
                    ?.IDAPCPH01 as any
                )?.[`${commonStore.language.key}`]
              } //"Select Picker Name"
              clearable
              value={pickerName}
              onChange={handleChange}
            />
            <Form.Field
              id="picker_phone: "
              control={Input}
              label={
                (
                  userLanguage[0].InventoryDeliveryAssignPickerComponent
                    ?.IDAPCL04 as any
                )?.[`${commonStore.language.key}`]
              } //"Picker Phone No "
              placeholder={
                (
                  userLanguage[0].InventoryDeliveryAssignPickerComponent
                    ?.IDAPCPH02 as any
                )?.[`${commonStore.language.key}`]
              } //"Picker Phone No"
              value={phoneNumber}
              onChange={(_e: any, { value }: { value: string }) =>
                setPhoneNumber(value)
              }
            />

            <Form.Field id="ReelNumber" label="" placeholder="" />
          </Form>
          <Button.Group
            style={{
              position: 'absolute',
              bottom: '5px',
              left: '5px',
            }}
          >
            <Button
              onClick={handleCancel}
              //Cancel
            >
              {
                (
                  userLanguage[0].InventoryDeliveryAssignPickerComponent
                    ?.IDAPCB01 as any
                )?.[`${commonStore.language.key}`]
              }
            </Button>
            <Button.Or
              text={
                (
                  userLanguage[0].InventoryDeliveryAssignPickerComponent
                    ?.IDAPCB03 as any
                )?.[`${commonStore.language.key}`]
              }
            />

            <Button
              disabled={phoneNumber?.length > 0 ? false : true}
              type="submit"
              content={
                (
                  userLanguage[0].InventoryDeliveryAssignPickerComponent
                    ?.IDAPCB02 as any
                )?.[`${commonStore.language.key}`]
              } //"Submit"
              positive
              onClick={handleSubmit}
              //Submit
            >
              {
                (
                  userLanguage[0].InventoryDeliveryAssignPickerComponent
                    ?.IDAPCB02 as any
                )?.[`${commonStore.language.key}`]
              }
            </Button>
          </Button.Group>
        </>
      ) : (
        <p
          style={{ marginTop: '-15px' }}
          // Please select item received
        >
          {
            (
              userLanguage[0].InventoryDeliveryAssignPickerComponent
                ?.IDAPCL02 as any
            )?.[`${commonStore.language.key}`]
          }
        </p>
      )}
    </Segment>
  );
}

export default observer(DeliveryAssignPicker);
